import React from 'react'
import { Container, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

const FirstMenstruationCycle = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  const isInMenopause = selectedClient?.bio?.clientBioFemale?.isInMenopause;

  return (
    <Container>
      <FormInfoWrapper>
        <p>At which age did you have your first monthly menstruation cycle?</p>
        <em>{selectedClient?.bio?.clientBioFemale?.firstMensAge}</em>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <p>In menopause?</p>
        <em>{isInMenopause === true ? 'Yes' : isInMenopause === false ? 'No' : '-'}</em>
      </FormInfoWrapper>
    </Container>
  )
}

export default FirstMenstruationCycle
